module.exports = __webpack_public_path__ + "assets/images/creatinina_r.c47f80f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/creatinina_r.png
// module id = 694
// module chunks = 1